<template>
  <div>
    <PromotionHeader :header="decodedProduct" :img_header="header_image" link_back="stock/promotion_stock/promotionset"/>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6" class="mt-4">
        <div class="img_flex">
          <div>
            <div class="pa-2">
              <div class="mt-4">
                <v-img height="200" width="200" max-width="200" v-if="header_list.promotion_image === null" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                <v-img height="200" width="200" max-width="200" v-if="header_list.promotion_image !== null" :src="header_list.promotion_image" class="preview mx-auto"></v-img>
              </div>
            </div>
          </div>
          <div>
            <div class="pl-6 pt-6 pr-6 grid_flex">
              <div class="grey--text grid_flex">
                <div class="mr-md-3 mr-lg-3 mr-xl-3">วันที่สิ้นสุดโปรโมชั่น</div>
                <div class="black--text">{{ date }}</div>
              </div>
              <div class="detail_flex">
                <div class="mr-2 grey--text">ยอดขาย <span class="ml-3 mr-3 black--text">{{ format_price(header_list.count_sale) }}</span>บาท</div>
              </div>
            </div>
            <div class="pl-6 pt-6 pr-6 grid_flex">
              <div class="grey--text grid_flex">
                <div class="mr-md-3 mr-lg-3 mr-xl-3">ราคาขาย(ต่อชุด)</div>
                <div class="black--text">{{ format_price(header_list.price_per_set) }}</div>
              </div>
              <div class="detail_flex">
                <div class="mr-2 grey--text">จำนวนคงเหลือ <span class="ml-3 mr-3 black--text">{{ format_number(header_list.quantity) }}</span>ชุด</div>
              </div>
            </div>
            <div class="pl-6 pt-6 pr-6 grid_flex">
              <div class="grey--text grid_flex">
                <div class="mr-md-3 mr-lg-3 mr-xl-3">แสดงสถานะการขาย</div>
                <div class="black--text" v-if="header_list.show_promotion === '1'">แสดงทั้งขายปลีก, ขายส่ง</div>
                <div class="black--text" v-else-if="header_list.show_promotion === '2'">แสดงเฉพาะขายปลีก</div>
                <div class="black--text" v-else-if="header_list.show_promotion === '3'">แสดงเฉพาะขายส่ง</div>
              </div>
            </div>
          </div>
        </div>
        <div class="pa-2">
          <v-card-title>
            <div class="mb-n10">
              สินค้าในชุด
            </div>
          </v-card-title>
          <v-card-title>
            <v-text-field color="#86bc3a" v-model="search" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="data_list" :search="search" mobile-breakpoint="0" hide-default-footer>
            <template v-slot:item="dataDetail" class="grid_btn">
              <tr>
                <td>{{ dataDetail.item.product_name }}</td>
                <td>{{ dataDetail.item.lot_no }}</td>
                <td>{{ dataDetail.item.date_expired }}</td>
                <td>{{ format_price(dataDetail.item.cost) }}</td>
                <td class="text-center">{{ format_number(dataDetail.item.quantity_per_sell) }}</td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr>
                <td colspan="3" class="text-center">รวมราคาต้นทุนของชุด</td>
                <td>{{ format_price(cost_total) }}</td>
                <td class="text-center">{{ format_number(quantity_set) }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-divider/>
          <div v-if="date_raw >= date_now" class="pl-6 pt-6 pr-6">
            <usercreate_promotion :user="header_list.user_name" :create_time="header_list.created_at" :status="header_list.status"/>
          </div>
          <div v-else class="pl-6 pt-6 pr-6">
            <usercreate_promotion :user="header_list.user_name" :create_time="header_list.created_at" :status="0"/>
          </div>
        </div>
        <div class="text-center mt-5 ma-3">
          <v-btn height="45" class="white--text grad-warning-bg btn_mobile mb-3 mr-2" type="button" @click="getEdit()">แก้ไขโปรโมชั่น</v-btn>
          <v-btn v-if="header_list.status === 1" height="45" class="white--text grad-danger-bg btn_mobile mb-3 mr-2" type="button" @click="checkTranfer = true">ย้ายคืนคลังหลัก</v-btn>
        </div>
      </v-card>
      <v-dialog v-model="checkTranfer" persistent max-width="800">
        <v-card>
          <v-card-title>
            ย้ายคืนคลังหลัก
          </v-card-title>
          <v-divider/>
          <div class="pa-5 text-center">
            <div>
              <p>คุณแน่ใจใช่ไหมที่จะทําการย้ายสินค้าโปรโมชั่นเข้าคลัง ย้ายคืนคลังหลัก ?</p>
              <p>- โปรโมชั่นจะปิดการขายทันที</p>
              <p>- สินค้าโปรโมชั่นที่ค้างอยู่ในตะกร้าสินค้าของลูกค้าจะหายไป</p>
            </div>
          </div>
          <div class="text-right mt-5 ma-3">
            <v-btn height="45" class="white--text grad-success-bg btn_mobile mb-3 mr-2" type="button" @click="move_to_main()">ยืนยันการย้ายคลัง</v-btn>
            <v-btn height="45" class="white--text grad-danger-bg btn_mobile mb-3 mr-2" type="button" @click="backward()">ยกเลิก</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import PromotionHeader from "@/components/admin/stock/storage_promotion/header_promotion/PromotionHeader";
import usercreate_promotion from "@/components/admin/stock/storage_promotion/header_promotion/usercreate_promotion";
import HeaderImage from "@/assets/boxes_set.png"
import {HTTP} from "@/axios";
import img_holder from "@/assets/pharmacy.png";
import {diffDateTH, formatNumber, formatPrice} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_set_details",
  components: {
    usercreate_promotion,
    PromotionHeader
  },
  data() {
    return {
      header_image: HeaderImage,
      img_holder: img_holder,
      loading_page: false,
      decodedProduct: null,
      date_now: null,
      search: null,
      date: null,
      date_raw: null,
      checkTranfer: false,
      headers: [
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'ล็อตสินค้า',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคาทุน',
          value: 'cost',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนในชุด',
          value: 'quantity_per_sell',
          fixed: true,
          align: 'center',
          width: '150px',
        },
      ],
      header_list: [],
      data_list: [],
    }
  },
  methods: {
    get_date() {
      let date_today = new Date();
      let day = date_today.getDate();
      let month = date_today.getMonth() + 1;
      let year = date_today.getFullYear();
      if (month < 10){
        month = '0'+ month
      }
      if (day < 10){
        day = '0'+ day
      }
      let date = year + '-' + month + '-' + day
      this.date_now = Date.parse(date)
    },
    diffTH: function (value) {
      return diffDateTH(value)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    diffDate_TH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'/'+month+'/'+year
      return this.date = final_date
    },
    move_to_main() {
      HTTP.post('/inventory/promotions/mains/cancel', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.checkTranfer = false
          this.$router.push('/stock/promotion_stock/promotionset')
        }
      })
    },
    backward() {
      this.$router.push('/stock/promotion_stock/promotionset')
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/promotions/mains/get', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.head
          this.decodedProduct = this.header_list.promotion_name;
          if (res.data.head.end_date !== null) {
            this.date_raw = Date.parse(res.data.head.end_date)
            this.date = res.data.head.end_date
            this.diffDate_TH(this.date)
          }
          else {
            this.date = ''
          }
          this.data_list = res.data.lists
        }
      })
    },
    getEdit() {
      this.$router.push('/stock/promotion_stock/promotionsetedit/' + this.$route.params.id)
    }
  },
  computed: {
    cost_total() {
      let data_list = this.data_list;
      let result = 0
      data_list.forEach((data) => {
        result += parseInt(data.cost)
      })
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    quantity_set() {
      let data_list = this.data_list;
      let result = 0
      data_list.forEach((data) => {
        result += parseInt(data.quantity_per_sell)
      })
      return result
    }
  },
  mounted() {
    this.get_date()
    this.get_data()
  }
}
</script>

<style scoped>
.grid_flex {
  display: flex;
  justify-content: space-between;
}
.detail_flex {
  display: flex;
}
.img_flex {
  display: grid;
  grid-template-columns: 30% 70%;
}
@media only screen and (max-width: 1180px) {
  .img_flex {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px){
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    text-align: center;
  }
  .detail_flex {
    display: grid;
    grid-template-columns: 100%;
    text-align: center;
  }
  .btn_mobile {
    width: 100%;
  }
}
</style>
